import { generateOptions } from '../../utils/Utils';
import FormikMultiSelect from '../../components/formik/FormikMultiSelect';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchLocations,
    getLocation,
} from '../../app/reducers/Location/locationSlice';
import { FieldArray, FormikProvider, useFormik } from 'formik';
import TableWithHeadingAndSearch from '../../components/Table/TableWithHeadingAndSearch';
import QueryString from 'qs';
import { authAxiosInstance } from '../../utils/axiosConfig';
import { Link } from 'react-router-dom';
import {
    fetchQualities,
    getQuality,
} from '../../app/reducers/Quality/qualitySlice';
import FormikSelectGroup from '../../components/formik/FormikSelectGroup';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { TableHeader } from '../../components/Table/TableHeader';
import { ClipLoader } from 'react-spinners';
import { createWriteOffSecond } from '../../app/api/writeOffSecond';

function CreateWriteOffSecond() {
    const dispatch = useDispatch();
    const { location } = useSelector(getLocation);
    const { quality } = useSelector(getQuality);
    const locationInfoId = localStorage.getItem('locationInfoId');
    const [cuttingData, setCuttingData] = useState([]);
    const [loading, setLoading] = useState(false);
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            location: locationInfoId ? [locationInfoId] : [],
            quality: [],
            cuttingData: [],
        },
        onSubmit: async (values) => {
            // formik.resetForm()
            console.log('cuttingData', values);
            if (values?.cuttingData?.length > 0) {
                setLoading(true);
                for (let i = 0; i < values?.cuttingData?.length; i++) {
                    let ele = values?.cuttingData[i];
                    console.log(ele);
                    if (ele?.reduceSecond && parseInt(ele?.reduceSecond) > 0) {
                        let payload = {
                            location: ele?.location?._id,
                            cuttingCardNumber:
                                ele?.cuttingCard?.cuttingCardNumber,
                            cuttingCardRef: ele?._id?.cuttingRef,
                            vendor: ele?.vendor,
                            vendorName: ele?.vendorName,
                            quantity: parseInt(ele?.reduceSecond),
                            quality: ele?.quality?._id,
                        };
                        await createWriteOffSecond(payload);
                        //APi Call
                    }
                }
                fetchCuttingDataDetails();
                setLoading(false);
            }
        },
    });

    const fetchCuttingDataDetails = async () => {
        const cuttingString = QueryString.stringify({
            populate: true,
            location: formik.values.location,
            quality: formik.values.quality,
            limit: 300,
        });
        const cuttingResp = await authAxiosInstance.get(
            `/inventory/cutting/byQuality?${cuttingString}`
        );
        if (cuttingResp?.data?.data?.docs?.length) {
            formik.setFieldValue(
                'cuttingData',
                cuttingResp?.data?.data?.docs.map((d) => ({
                    ...d,
                    reduceSecond: '',
                }))
            );
            setCuttingData(
                cuttingResp?.data?.data?.docs.map((d) => ({
                    ...d,
                    reduceSecond: '',
                }))
            );
        } else {
            formik.setFieldValue('cuttingData', []);
            setCuttingData([]);
        }
    };

    useEffect(async () => {
        fetchCuttingDataDetails();
    }, [
        JSON.stringify(formik.values.location),
        JSON.stringify(formik.values.quality),
    ]);

    useEffect(() => {
        dispatch(fetchLocations());
        dispatch(fetchQualities({ limit: 400 }));
    }, []);

    const qualityMemo = useMemo(() => quality.docs ?? [], [quality.docs]);

    const cuttingMemo = [
        {
            Header: 'SRNO',
            Cell: (prop) => {
                const { data, row } = prop;
                return row.index + 1;
            },
        },
        {
            Header: 'Cutting Card#',
            accessor: 'cuttingCard.cuttingCardNumber',
            Cell: ({ row }) => {
                return row.original.cuttingCard.cuttingCardNumber;
            },
        },
        {
            Header: 'Quality name',
            accessor: 'quality.name',
            Cell: ({ row }) => {
                const linkBinaryEncoded = btoa(
                    JSON.stringify({
                        location: formik.values.location,
                        quality: row.original._id.quality,
                        qualityName: row.original.quality.name,
                    })
                );
                return (
                    <Link
                        className="text-indigo-600 underline"
                        to={`/dashboard/cutting/quality-inventory/${linkBinaryEncoded}`}
                    >
                        {row.original.quality.name}
                    </Link>
                );
            },
        },
        {
            Header: 'Location',
            accessor: 'location.name',
        },
        {
            Header: 'Fresh',
            Cell: ({ row }) => {
                return <div>{row.original['stagesMap']['fresh']}</div>;
            },
        },
        {
            Header: 'Second',
            Cell: ({ row }) => {
                return <div>{row.original['stagesMap']['second']}</div>;
            },
        },
        {
            Header: 'Action',
            Cell: ({ row, index }) => {
                return (
                    <div>
                        <form>
                            <FormikInputGroup
                                name={`writeInput.${index}`}
                                formik={formik}
                            />
                            <PrimaryButton>Submit</PrimaryButton>
                        </form>
                    </div>
                );
            },
        },
    ];
    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="mb-8">
                <h1 className="text-2xl md:text-3xl text-slate-800 font-bold">
                    WriteOffSecond
                </h1>
            </div>
            <form onSubmit={formik.handleSubmit}>
                <div className="flex gap-4">
                    <FormikMultiSelect
                        formik={formik}
                        label="Location"
                        onChange={async (selectedOption) => {
                            const data = {
                                location: {
                                    $in: selectedOption.map((ele) => ele.value),
                                },
                            };

                            formik.setFieldValue(
                                `location`,
                                selectedOption.map((ele) => ele.value)
                            );
                        }}
                        name="location"
                        required
                        options={generateOptions({
                            array: location ? location.docs : [],
                            valueField: '_id',
                            labelField: 'name',
                        })}
                    />
                    <FormikSelectGroup
                        formik={formik}
                        label="Quality"
                        onChange={async (selectedOption) => {
                            formik.setFieldValue(
                                `quality`,
                                selectedOption.value
                            );
                        }}
                        name="quality"
                        required
                        options={generateOptions({
                            array: qualityMemo,
                            valueField: '_id',
                            labelField: 'name',
                        })}
                    />
                </div>

                <div className="mt-3">
                    <div className="mt-3">
                        {loading ? (
                            <ClipLoader />
                        ) : (
                            <FormikProvider value={formik}>
                                <FieldArray
                                    name="cuttingData"
                                    render={(arrayHelpers) => {
                                        return (
                                            <>
                                                <table className="table-auto w-full">
                                                    <TableHeader
                                                        headers={[
                                                            {
                                                                name: 'Sr No.',
                                                                style: {
                                                                    minWidth:
                                                                        '20px',
                                                                },
                                                            },
                                                            {
                                                                name: 'Cutting Card No.',
                                                                style: {
                                                                    minWidth:
                                                                        '80px',
                                                                },
                                                            },
                                                            {
                                                                name: 'Quality Name',
                                                                style: {
                                                                    minWidth:
                                                                        '80px',
                                                                },
                                                            },
                                                            {
                                                                name: 'Fresh',
                                                                style: {
                                                                    minWidth:
                                                                        '20px',
                                                                },
                                                            },
                                                            {
                                                                name: 'Second',
                                                                style: {
                                                                    minWidth:
                                                                        '80px',
                                                                },
                                                            },
                                                            {
                                                                name: 'Action',
                                                                style: {
                                                                    minWidth:
                                                                        '30px',
                                                                },
                                                            },
                                                        ]}
                                                    />
                                                    <tbody className="text-sm">
                                                        {formik.values?.cuttingData.map(
                                                            (ele, index) => (
                                                                <tr
                                                                    key={`${ele.cuttingCard.cuttingCardNumber}_${index}`}
                                                                >
                                                                    <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                                                        <div className="flex gap-4">
                                                                            {index +
                                                                                1}
                                                                            .
                                                                        </div>
                                                                    </td>
                                                                    <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                                                        <div>
                                                                            {
                                                                                ele
                                                                                    .cuttingCard
                                                                                    .cuttingCardNumber
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                    <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                                                        <div>
                                                                            {
                                                                                ele
                                                                                    .quality
                                                                                    .name
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                    <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                                                        <div>
                                                                            {
                                                                                ele[
                                                                                    'stagesMap'
                                                                                ][
                                                                                    'fresh'
                                                                                ]
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                    <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                                                        <div>
                                                                            {
                                                                                ele[
                                                                                    'stagesMap'
                                                                                ][
                                                                                    'second'
                                                                                ]
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                    <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                                                        <div>
                                                                            <FormikInputGroup
                                                                                type="number"
                                                                                name={`cuttingData.${index}.reduceSecond`}
                                                                                formik={
                                                                                    formik
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                </table>
                                            </>
                                        );
                                    }}
                                ></FieldArray>
                            </FormikProvider>
                        )}
                    </div>
                </div>
                <div>
                    <PrimaryButton
                        onClick={() => {
                            console.log('clicked');
                            formik.handleSubmit();
                        }}
                        type="button"
                    >
                        Submit
                    </PrimaryButton>
                </div>
            </form>
        </div>
    );
}

export default CreateWriteOffSecond;
